import { c as _c } from "react/compiler-runtime";
import { PricePlanId } from '@systemeio/types';
import { useControlledSwr } from '@systemeio/util';
import { DIGITAL_PRODUCT_API } from 'modules/digital-product/api';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { PricePlanCountInterface } from '../types/price-plan-interface';
export function usePricePlansCount(shouldFetch, pricePlanId) {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== pricePlanId || $[2] !== shouldFetch) {
    t1 = () => {
      if (shouldFetch && pricePlanId) {
        return [`${DIGITAL_PRODUCT_API}/count/by-price-plan/${pricePlanId}`, RequestModuleEnum.PricePlans];
      }
      return null;
    };
    $[1] = pricePlanId;
    $[2] = shouldFetch;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return useControlledSwr(t1, fetcher);
}